import React, {useEffect} from "react"

type Props = {}

const OnePricingSection = (props: Props) => {
	useEffect(() => {
		const script1 = document.createElement("script")
		script1.src = "/pricingTableBundle9.js"
		script1.async = true

		script1.onload = () => {
			try {
				// @ts-expect-error Just no type for it
				if (typeof window?.ComparePricingTableWidget !== "undefined") {
					const element = document.getElementById("first-one-prices")
					if (element) {
						// @ts-expect-error Just no type for it
						window?.ComparePricingTableWidget.mount(
							"first-one-prices",
							2,
						)
					}
				}
			} catch (error) {}
		}
		document.body.appendChild(script1)
		return () => {
			document.body.removeChild(script1)
		}
	}, [])

	return (
		<>
			<div id={"first-one-prices"} />
		</>
	)
}

export default OnePricingSection
